import { http } from '../utils/http';

export const userHandler = {
  fetchUsersDropDown: async () => {
    return await http.get(`/User/FetchUsersDropDown`);
  },
  checkUserExists: async (userName, email) => {
    return await http.get(`/User/CheckUserExists?userName=${userName}&email=${email}`);
  },
  fetchUsers: async (searchText, sortColumn, sortingOrder, pageIndex, pageSize) => {
    return await http.get(
      `/User/FetchUsers?searchTerm=${searchText}&sortColumn=${sortColumn}&sortOrder=${sortingOrder}&page=${pageIndex + 1}&pageSize=${pageSize}`
    );
  },
  fetchUserImage: async (userId = 0) => {
    return await http.get(`/User/FetchUserImage?userId=${userId}`);
  },
  setUserImage: async (imageBase64) => {
    return await http.post('/User/SetUserImage', { imageBase64: imageBase64 });
  },
  createUser: async (payload) => {
    return await http.post('/User/Register', payload);
  },
  updateUser: async (payload) => {
    return await http.put('/User/UpdateUser', payload);
  },
  deleteUser: async (emailId) => {
    return await http.deleteItems(`/User/DeleteUser?emailId=${emailId}`);
  },
};
